<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-button size="medium" @click="addPrice">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" style="width: 100%" border stripe>
      <el-table-column prop="index" label="序号" width="80" type="index"></el-table-column>
      <el-table-column prop="NAME" label="比价包"></el-table-column>
      <el-table-column prop="PRICE_CYCLE" label="报价周期"></el-table-column>
      <!-- <el-table-column prop="STATUS" label="状态">
                <template slot-scope="scope">
                    <span v-if="scope.row.STATUS == 1">未发起报价</span>
                    <span v-if="scope.row.STATUS == 2">已发起报价</span>
                </template>
            </el-table-column> -->
      <el-table-column prop="action" label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editName(scope.row)">修改</el-button>
          <el-button type="text" size="small" @click="deleteName(scope.row)">删除</el-button>
          <el-button type="text" size="small" @click="checkSKU(scope.row)">查看SKU</el-button>
          <el-button type="text" size="small" @click="checkSupplier(scope.row)">查看供应商</el-button>
          <!-- <el-button type="text" size="small" @click="exportTable(scope.row)">导出</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 新增 -->
    <el-dialog :visible.sync="addDialog" @close="addDialog = false" title="新增比价包" width="400px" center>
      <el-form ref="addForm" v-model="addForm" :inline="true">
        <el-form-item style="margin-right: 0px" label="比价包" :label-width="formLableWidth">
          <el-input v-model="addForm.NAME"></el-input>
        </el-form-item>
        <el-form-item style="margin-right: 0px" label="报价周期" :label-width="formLableWidth">
          <el-input v-model="addForm.PRICE_CYCLE"></el-input>
        </el-form-item>
        <!-- <el-form-item label="开始日期：" :label-width="formLableWidth">
                    <el-date-picker v-model="addForm.startDate" align="right" type="date" placeholder="请选择开始日期" value-format="yyyy-MM-dd" style="width: 100%">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期：" :label-width="formLableWidth">
                    <el-date-picker v-model="addForm.endDate" align="right" type="date" placeholder="请选择结束日期" value-format="yyyy-MM-dd"  style="width: 100%">
                    </el-date-picker>
                </el-form-item> -->
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button class="operate-btn" @click="addDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="submitAddPrice">确认</el-button>
      </div>
    </el-dialog>
    <!-- 修改 -->
    <el-dialog :visible.sync="editDialog" @close="editDialog = false" title="修改比价包" width="400px" center>
      <el-form ref="editForm" v-model="editForm" :inline="true">
        <el-form-item label="比价包" :label-width="formLableWidth">
          <el-input v-model="editForm.NAME"></el-input>
        </el-form-item>
        <el-form-item label="报价周期" :label-width="formLableWidth">
          <el-input v-model="editForm.PRICE_CYCLE"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button class="operate-btn" @click="editDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="submitEditPrice">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      value: '',
      tableData: [],
      fileList: [],
      supplierList: [],
      formLableWidth: '100px',
      addForm: {},
      addDialog: false,
      // 修改模态框
      editDialog: false,
      editForm: {},
    };
  },
  created() {
    this.getPriceList();
  },
  methods: {
    // 获取比价列表
    getPriceList() {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 12,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((res) => {
        if (res.length == 0) {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
        this.tableData = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 新增比价包
    submitAddPrice() {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 13,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.addForm.NAME) {
        params.NAME = this.addForm.NAME;
      } else {
        this.$message.show({ text: '请输入比价包', type: 'warning' });
        return false;
      }
      if (this.addForm.PRICE_CYCLE) {
        params.PRICE_CYCLE = this.addForm.PRICE_CYCLE;
      } else {
        this.$message.show({ text: '请输入报价周期', type: 'warning' });
        return false;
      }
      const reg = /^[0-9]*[1-9][0-9]*$/;
      if (!reg.test(this.addForm.PRICE_CYCLE)) {
        this.$message.show({ text: '请输入正数报价周期', type: 'warning' });
        return false;
      }
      http.post(params).then((result) => {
        this.$message.show({ text: '新增成功', type: 'success' });
        this.addDialog = false;
        this.addForm = {};
        this.getPriceList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 修改比价包
    editName(row) {
      this.editDialog = true;
      this.editForm = row;
    },
    // 提交修改模态框
    submitEditPrice() {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 15,
        F_CAT_ID: this.editForm.ID,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.editForm.NAME) {
        params.NAME = this.editForm.NAME;
      } else {
        this.$message.show({ text: '请输入比价包', type: 'warning' });
        return false;
      }
      if (this.editForm.PRICE_CYCLE) {
        params.PRICE_CYCLE = this.editForm.PRICE_CYCLE;
      } else {
        this.$message.show({ text: '请输入报价周期', type: 'warning' });
        return false;
      }
      http.post(params).then((result) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.editDialog = false;
        this.getPriceList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 删除比价包
    deleteName(row) {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 14,
        F_CAT_ID: row.ID,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '删除成功', type: 'success' });
        this.getPriceList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 查看SKU
    checkSKU(row) {
      this.$router.push({ path: `/checkSku/${row.ID}`, params: { id: row.ID } });
    },
    exportTable(row) {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 11,
        COMPARE_ID: row.COMPARE_ID,
      };
      http.post(params).then((res) => {
        if (res.length === 0) {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        } else {
          window.location.href = res[0].FILE_PATH;
          this.$message.show({ text: '导出成功', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    addPrice() {
      this.addDialog = true;
    },
    checkSupplier(row) {
      this.$router.push({ path: `/compareDetail/${row.ID}`, params: { id: row.ID } });
    },

  },

};
</script>
<style scoped>
.pagination_box {
  float: right;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/priceManagement/configPrice.vue